import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { SchedulesContainerProps } from "../../../interfaces/containers";
import Schedules from "../../../pages/Profile/Schedules";
import { getSchedules, cleanSchedules } from "../../../actions/profile";

function mapStateToProps(state: SchedulesContainerProps) {
    return {
        schedules: state.profile.schedules
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getSchedules,
        cleanSchedules
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Schedules);